<!-- Main Ports Modal -->
<div class="modal-backdrop fade show" *ngIf="showModal" (click)="close()"></div>
<div class="modal fade show d-block" *ngIf="showModal" tabindex="-1" role="dialog">
  <div class="modal-dialog modal-lg modal-dialog-centered">
    <div class="modal-content">
      <!-- Modal Header -->
      <div class="modal-header">
        <div>
          <h4 class="modal-title mb-1">Port Management</h4>
        </div>
        <button type="button" class="btn-close" (click)="close()"></button>
      </div>

      <!-- Modal Body -->
      <div class="modal-body">
        <div class="d-flex justify-content-between align-items-center mb-3">
          <div>
            <h5 class="mb-1">Ports</h5>
            <p class="text-muted small mb-0">Manage port information and locations</p>
          </div>
          <button class="btn btn-primary" (click)="openAddPortModal()">
            <i class="bi bi-plus"></i> Add Port
          </button>
        </div>

        <!-- Search -->
        <div class="mb-3">
          <input type="text" class="form-control" placeholder="Search ports..."
                 [(ngModel)]="searchTerm" (input)="filterPorts()" />
        </div>

        <!-- Ports Table -->
        <div class="table-responsive">
          <table class="table table-hover">
            <thead>
              <tr>
                <th>Code</th>
                <th>Name</th>
                <th>Country</th>
                <th>Region</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let port of filteredPorts">
                <td>{{ port.code }}</td>
                <td>{{ port.name }}</td>
                <td>{{ port.country }}</td>
                <td>{{ port.region }}</td>
                <td>
                  <button class="btn btn-sm btn-link" (click)="editPort(port)" title="Edit">
                    <i class="bi bi-pencil"></i>
                  </button>
                  <button class="btn btn-sm btn-link text-danger" (click)="deletePort(port.id)" title="Delete">
                    <i class="bi bi-trash"></i>
                  </button>
                </td>
              </tr>
              <tr *ngIf="filteredPorts.length === 0">
                <td colspan="5" class="text-center text-muted">No ports found</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Nested Add Port Modal -->
<div class="modal-backdrop fade show" *ngIf="showAddModal"
     style="z-index: 1055 !important; background-color: rgba(0, 0, 0, 0.85) !important;"
     (click)="closeAddPortModal()"></div>
<div class="modal fade show d-block" *ngIf="showAddModal"
     style="z-index: 1056 !important;"
     tabindex="-1" role="dialog">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content" (click)="$event.stopPropagation()">
      <!-- Add Port Header -->
      <div class="modal-header">
        <h5 class="modal-title">Add New Port</h5>
        <button type="button" class="btn-close" (click)="closeAddPortModal()"></button>
      </div>

      <!-- Add Port Body -->
      <div class="modal-body">
        <div class="mb-3">
          <label class="form-label">Port Code <span class="text-danger">*</span></label>
          <input type="text" class="form-control" placeholder="e.g., USNYC"
                 [(ngModel)]="formData.code" />
        </div>

        <div class="mb-3">
          <label class="form-label">Port Name <span class="text-danger">*</span></label>
          <input type="text" class="form-control" placeholder="e.g., New York"
                 [(ngModel)]="formData.name" />
        </div>

        <div class="mb-3">
          <label class="form-label">Country <span class="text-danger">*</span></label>
          <input type="text" class="form-control" placeholder="e.g., United States"
                 [(ngModel)]="formData.country" />
        </div>

        <div class="mb-3">
          <label class="form-label">Region <span class="text-danger">*</span></label>
          <input type="text" class="form-control" placeholder="e.g., North America"
                 [(ngModel)]="formData.region" />
        </div>
      </div>

      <!-- Add Port Footer -->
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="closeAddPortModal()">Cancel</button>
        <button type="button" class="btn btn-primary" (click)="createPort()">Create</button>
      </div>
    </div>
  </div>
</div>

<!-- Nested Edit Port Modal -->
<div class="modal-backdrop fade show" *ngIf="showEditModal"
     style="z-index: 1055 !important; background-color: rgba(0, 0, 0, 0.85) !important;"
     (click)="closeEditPortModal()"></div>
<div class="modal fade show d-block" *ngIf="showEditModal"
     style="z-index: 1056 !important;"
     tabindex="-1" role="dialog">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content" (click)="$event.stopPropagation()">
      <!-- Edit Port Header -->
      <div class="modal-header">
        <h5 class="modal-title">Edit Port</h5>
        <button type="button" class="btn-close" (click)="closeEditPortModal()"></button>
      </div>

      <!-- Edit Port Body -->
      <div class="modal-body">
        <div class="mb-3">
          <label class="form-label">Port Code <span class="text-danger">*</span></label>
          <input type="text" class="form-control" placeholder="e.g., USNYC"
                 [(ngModel)]="editFormData.code" />
        </div>

        <div class="mb-3">
          <label class="form-label">Port Name <span class="text-danger">*</span></label>
          <input type="text" class="form-control" placeholder="e.g., New York"
                 [(ngModel)]="editFormData.name" />
        </div>

        <div class="mb-3">
          <label class="form-label">Country <span class="text-danger">*</span></label>
          <input type="text" class="form-control" placeholder="e.g., United States"
                 [(ngModel)]="editFormData.country" />
        </div>

        <div class="mb-3">
          <label class="form-label">Region <span class="text-danger">*</span></label>
          <input type="text" class="form-control" placeholder="e.g., North America"
                 [(ngModel)]="editFormData.region" />
        </div>
      </div>

      <!-- Edit Port Footer -->
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="closeEditPortModal()">Cancel</button>
        <button type="button" class="btn btn-primary" (click)="updatePort()">Update</button>
      </div>
    </div>
  </div>
</div>
